
import React from 'react';
import { Play, Info } from 'lucide-react';

const GameHero = () => {
  return (
    <div className="relative overflow-hidden">
      <div className="bg-gradient-to-r from-blue-800 to-indigo-700 py-16 md:py-24">
        <div className="container mx-auto px-6 relative z-10">
          <div className="flex flex-col items-center text-center">
            <h1 className="text-4xl md:text-6xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-yellow-300 via-red-400 to-yellow-300 mb-4 animate-pulse">
              Pokemon Clicker
            </h1>
            <p className="text-xl md:text-2xl text-blue-100 max-w-3xl mb-8">
              Catch, train, and evolve Pokemon in this addictive free online incremental game!
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <a 
                href="#play-now" 
                className="flex items-center bg-gradient-to-r from-red-500 to-yellow-500 hover:from-red-600 hover:to-yellow-600 text-white font-bold py-3 px-8 rounded-full transition-all transform hover:scale-105 hover:shadow-lg"
              >
                <Play className="w-5 h-5 mr-2" />
                Play Now
              </a>
              <a 
                href="#game-guide" 
                className="flex items-center bg-transparent border-2 border-blue-300 text-blue-100 hover:bg-blue-800 font-bold py-3 px-8 rounded-full transition-all transform hover:scale-105"
              >
                <Info className="w-5 h-5 mr-2" />
                Game Guide
              </a>
            </div>
          </div>
        </div>

        {/* Animated Pokeball particles effect */}
        <div className="absolute inset-0 overflow-hidden">
          {[...Array(15)].map((_, i) => (
            <div 
              key={i}
              className="absolute rounded-full bg-white opacity-20 animate-pulse"
              style={{
                top: `${Math.random() * 100}%`,
                left: `${Math.random() * 100}%`,
                width: `${Math.random() * 15 + 5}px`,
                height: `${Math.random() * 15 + 5}px`,
                animationDuration: `${Math.random() * 5 + 2}s`,
                animationDelay: `${Math.random() * 2}s`
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default GameHero;
